@keyframes shimmer {
    0% {
        background-position: -1000px 0;
    }
    100% {
        background-position: 1000px 0;
    }
}

.shimmer-rectangle {
    background: linear-gradient(
        90deg,
        var(--ai-purple-pink-lt) 0%,
        var(--ai-purple-pink-lt) 45%,
        var(--ai-purple-pink-xlt) 50%,
        var(--ai-purple-pink-lt) 55%,
        var(--ai-purple-pink-lt) 100%
    );
    background-size: 1000px 100%;
    border-radius: 4px;
    animation: shimmer 8s linear infinite;
}

.container {
    padding: 24px;
    height: 100%;
    box-sizing: border-box;
}

.shimmer-large {
    height: 120px;
    width: 100%;
}

.shimmer-medium {
    height: 40px;
    width: 60%;
    margin: 0 auto;
}

.shimmer-small {
    height: 24px;
    width: 85%;
}

.shimmer-small-centered {
    height: 24px;
    width: 60%;
    margin: 0 auto;
}
